import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../Api';

export const getEmailTemplatesRequest = createAsyncThunk('email-templates/get', async (payload = {}) => {
  const { path, ...reqData } = payload;
  const { data } = await Api.getEmailTemplates(reqData);

  return { data, path };
});
